import React, { useState } from 'react';
import {  BiFile } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { DocumentDetailsModal } from './DocumentDetailsModal';

// Document Card Component
const DocumentCard = ({ document, onClick }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className="card shadow-sm mb-2"
      style={{ 
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid #e0e0e0',
        transform: isHovered ? 'translateX(5px)' : 'translateX(0)', 
        boxShadow: isHovered ? '0 4px 12px rgba(0,0,0,0.1)' : '0 1px 3px rgba(0,0,0,0.05)',
        width: '100%', 
        overflow: 'hidden' 
      }}
      onClick={() => onClick(document)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="card-body p-3" style={{ minWidth: 0 }}> 
        <div className="d-flex justify-content-between align-items-center mb-2" style={{ minWidth: 0 }}>
          <h5 className="card-title mb-0" style={{ 
            color: '#730595ff', 
            fontWeight: 'bold', 
            fontSize: '1.1rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            marginRight: '0.5rem',
            minWidth: 0
          }}>
            {document.title}
          </h5>
          <span 
            className="badge"
            style={{ 
              backgroundColor: document.target_audience === 'staff' ? '#e3f2fd' : '#fce4ec',
              color: document.target_audience === 'staff' ? '#1976d2' : '#c2185b',
              fontWeight: '500',
              fontSize: '0.75rem',
              padding: '0.35rem 0.65rem',
              flexShrink: 0,
              whiteSpace: 'nowrap'
            }}
          >
            {document.target_audience === 'staff' ? t('document_model.staff') : t('document_model.parents')}
          </span>
        </div>
        
        <div className="d-flex flex-wrap gap-2 mb-2">
          {document.room_names?.slice(0, 3).map((room, idx) => (
            <span key={idx} className="badge" style={{ backgroundColor: '#f5f5f5', color: '#666', fontWeight: 'normal', fontSize: '0.75rem' }}>
              {room}
            </span>
          ))}
          {document.room_names?.length > 3 && (
            <span className="badge" style={{ backgroundColor: '#f5f5f5', color: '#666', fontWeight: 'normal', fontSize: '0.75rem' }}>
              +{document.room_names.length - 3} {t('document_model.more', 'more')}
            </span>
          )}
        </div>
        
        <div className="d-flex justify-content-between align-items-center mt-3 pt-2" style={{ borderTop: '1px solid #f0f0f0' }}>
          <small className="text-muted d-flex align-items-center gap-1">
            <BiFile size={16} />
            {document.document_count || 0} {t('document_model.files', 'files')}
          </small>
          <small className="text-muted">
            {new Date(document.created_at).toLocaleDateString()}
          </small>
        </div>
      </div>
    </div>
  );
};




// Main Document Cards Component
export const DocumentCards = ({ documents, onDelete, onEdit }) => {
  const { t , i18n} = useTranslation();
  const isAr = i18n.language === 'ar';
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  
  const handleCardClick = (document) => {
    setSelectedDocumentId(document.id);
    setShowDetails(true);
  };
  
  const handleCloseDetails = () => {
    setShowDetails(false);
    setTimeout(() => {
      setSelectedDocumentId(null);
    }, 300);
  };
  
  if (!documents || documents.length === 0) {
    return (
      <div 
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '300px' }}
      >
        <h6 className="text-muted">
          {isAr ? "لا توجد مستندات متاحة." : "No documents available."}
        </h6>
      </div>
    );
  }
  
  return (
    <div className="container-fluid px-0"> 
      <div className="row g-2">
        {documents.map((doc) => (
          <div key={doc.id} className="col-12 px-0"> 
            <DocumentCard document={doc} onClick={handleCardClick} />
          </div>
        ))}
      </div>
      
      <DocumentDetailsModal 
        open={showDetails}
        onClose={handleCloseDetails}
        documentId={selectedDocumentId}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    </div>
  );
};